import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import Portal from "./Portal";
import FilterValue from "../../site/components/FilterValues";
import ReactTooltip from "react-tooltip";
import ShowHelperModal from "../../helper/components/ShowHelperModal";
import SelectExportTypeModal from "./SelectExportTypeModal";
import NewlyCreated from "../../../assets/img/Group7.svg";
import NewlyEdited from "../../../assets/img/Group6.svg";
import GlobalSearch from "./GlobalSearch";
import { ExportPopup } from "../../recommendations/components/ExportPopup";
import FilterIcon from "../../../assets/img/dashboard/filter-butn.svg";
import refreshIcon from "../../../assets/img/img-refresh.svg";
import SurveyorIcon from "../../../assets/img/dashboard/surveyor.svg";
import InfoIcon from "../../../assets/img/help-blue.svg";
import { getAppliedFiltersCount, getAppliedListFilterCount, getAppliedWildCardFilterCount } from "../../../utils/filtersUtils";
import { getAssetDashboardAppliedFilterCount } from "../../assetDashboard/utils";
import ReactSelect from "react-select";
import ConfirmationModal from "./ConfirmationModal";
import { connect } from "react-redux";
import QuestionIcon from "../../../assets/img/dashboard/question.svg";
import { findPrevPathFromBreadCrumpData, popBreadCrumpOnPageClose } from "../../../config/utils";
import { Dropdown } from "react-bootstrap";
import { sanitizeHtml } from "./SafeHtml";
import SurveydDateIcon from "../../../assets/img/calendar.svg";
import syncCalender from "../../../assets/img/sync-calender.svg";
import bgTaskProgressIcon from "../../../assets/img/bg-task-progress.svg";
import bgTaskProgressFailedIcon from "../../../assets/img/bg-task-progress-failed.svg";
import DateFilterCalendar from "./DateFilterCalender";

class TableTopIcons extends Component {
    state = {
        viewFilterModal: false,
        showHelperModal: false,
        selectedHelperItem: {},
        showResetTableConfigModal: false,
        showLogDateFilter: false
    };
    logDateFilterWrapRef = React.createRef();

    componentDidMount() {
        if (this.props.openExportToWordModalTrigger) {
            this.showSelectExportTypeWordModal(true);
        }
        document.addEventListener("mousedown", this.handleLogDateFilterClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleLogDateFilterClickOutside);
    }

    handleLogDateFilterClickOutside = e => {
        const wrap = this?.logDateFilterWrapRef?.current;
        if (!wrap) return;
        if (!wrap?.contains(e.target)) {
            this.setState(prev => (prev?.showLogDateFilter ? { showLogDateFilter: false } : null));
        }
    };

    toggleLogDateFilter = e => {
        e?.stopPropagation();
        this.setState(prev => ({ showLogDateFilter: !prev.showLogDateFilter }));
    };

    handleLogDateFilterChangeInternal = value => {
        this.props.handleLogDateFilterChange?.(value);
        this.setState({ showLogDateFilter: false });
    };

    componentDidUpdate(prevProps) {
        if (
            this.props.openExportToWordModalTrigger &&
            this.props.openExportToWordModalTrigger !== prevProps.openExportToWordModalTrigger
        ) {
            this.showSelectExportTypeWordModal(true);
        }
        if (
            !!this.props.showMultiEditPorgress !== !!prevProps.showMultiEditPorgress ||
            !!this.props.progressFailed !== !!prevProps.progressFailed
        ) {
            ReactTooltip.rebuild();
        }
    }

    isFiltered = () => {
        const { tableParams = {}, isRecommendationLog = false } = this.props;
        if (tableParams.list && !_.isEmpty(tableParams.list) && Object.values(tableParams.list).some(e => e)) {
            return true;
        }
        if (tableParams.filters && !_.isEmpty(tableParams.filters)) {
            const filters = Object.keys(tableParams.filters);
            if (Object.values(tableParams.filters).every(item => item.key === null)) {
                return false;
            }
            for (const item of filters) {
                if (tableParams.filters[item] && tableParams.filters[item].key && tableParams.filters[item].key.length) {
                    return true;
                }
                if (
                    tableParams.filters[item] &&
                    tableParams.filters[item].filters &&
                    (tableParams.filters[item].filters.includes("not_null") ||
                        tableParams.filters[item].filters.includes("null") ||
                        tableParams.filters[item].filters.includes("count_gt_1"))
                ) {
                    return true;
                }
            }
            return true;
        }
        if (
            tableParams.recommendation_ids?.length ||
            this.props.globalSearchKey ||
            tableParams.image_or_not ||
            tableParams.review_status ||
            tableParams.qa_qc_status ||
            tableParams.recommendation_assigned_true ||
            tableParams.guid_assigned ||
            tableParams.has_image ||
            tableParams?.surveyor ||
            tableParams?.requestor ||
            tableParams?.infrastructure_request ||
            tableParams?.water ||
            tableParams?.caption_missing ||
            tableParams?.caption_missing === false ||
            tableParams?.energy ||
            tableParams?.fmp ||
            tableParams?.facility_master_plan ||
            tableParams?.recommendation_type ||
            tableParams?.budget_priority ||
            tableParams.opinions_cost_vs_project_total ||
            tableParams?.recommendation_ids?.length ||
            (tableParams?.selectedDropdown && tableParams?.selectedDropdown !== "unlocked") ||
            (isRecommendationLog &&
                (tableParams?.count_ids?.length ||
                    tableParams?.user_ids?.length ||
                    tableParams?.region_ids?.length ||
                    tableParams?.site_ids?.length ||
                    tableParams?.building_ids?.length))
        ) {
            return true;
        }
        return false;
    };
    isSorted = () => {
        const { tableParams = {} } = this.props;
        if (tableParams.order && !_.isEmpty(tableParams.order)) {
            return true;
        }
        if (tableParams?.priority_elements && tableParams?.priority_elements?.length) {
            return true;
        }
        return false;
    };

    isSelected = () => {
        const { tableParams = {} } = this.props;
        if (tableParams.deleted || tableParams.active || tableParams.locked || tableParams.unlocked) {
            return true;
        }

        return false;
    };

    setFilterModal = () => {
        this.setState({
            viewFilterModal: true
        });
    };

    showHelperModal = async (item, subItem) => {
        await this.setState({
            showHelperModal: true,
            selectedHelperItem: {
                item,
                subItem
            }
        });
    };

    renderUploadHelperModal = () => {
        const { showHelperModal, selectedHelperItem } = this.state;
        if (!showHelperModal) return null;
        return (
            <Portal
                body={<ShowHelperModal selectedHelperItem={selectedHelperItem} onCancel={() => this.setState({ showHelperModal: false })} />}
                onCancel={() => this.setState({ showHelperModal: false })}
            />
        );
    };

    showSelectExportTypeWordModal = async showSelectExportTypeWordModal => {
        await this.setState({
            showSelectExportTypeWordModal
        });
    };

    renderSelectExportTypeWordModal = () => {
        const { showSelectExportTypeWordModal } = this.state;
        const { exportToWord, exportToExcel } = this.props;
        if (!showSelectExportTypeWordModal) return null;
        return (
            <Portal
                body={
                    <ExportPopup
                        onRegularDownload={this.props.exportTableXl}
                        isRegularExportLoading={this.props.tableLoading}
                        exportLoader={this.props.exportWordLoading}
                        onSortedDownload={(sort_type, file_type, exportParam) => {
                            if (file_type === "word") {
                                exportToWord(sort_type, exportParam);
                            } else {
                                exportToExcel(sort_type, exportParam);
                            }
                        }}
                        viewSortedExportSettings={this.props.showViewModalExport}
                        onCancel={() => this.showSelectExportTypeWordModal(false)}
                        handleNormalRecomGrouping={this.props?.handleNormalRecomGrouping}
                        isNormalRecomGroupingLoading={this.props?.isNormalRecomGroupingLoading}
                        isCapitalRequest={this.props.isCapitalRequest}
                    />
                }
                onCancel={() => this.showSelectExportTypeWordModal(false)}
            />
        );
    };

    showSelectExportTypeExcelModal = async showSelectExportTypeExcelModal => {
        await this.setState({
            showSelectExportTypeExcelModal
        });
    };

    showSelectExportTypeModal = async showSelectExportTypeModal => {
        await this.setState({
            showSelectExportTypeModal
        });
    };

    renderSelectExportTypeModal = () => {
        const { showSelectExportTypeModal } = this.state;
        const { exportExcelAllTrades } = this.props;
        if (!showSelectExportTypeModal) return null;
        return (
            <Portal
                body={
                    <SelectExportTypeModal
                        type="cancel"
                        heading={"Please select export type."}
                        onCancel={() => this.showSelectExportTypeModal(false)}
                        onOk={export_type => {
                            this.showSelectExportTypeModal(false);
                            exportExcelAllTrades(export_type);
                        }}
                    />
                }
                onCancel={() => this.showSelectExportTypeModal(false)}
            />
        );
    };
    setSortOrderParamsByArrow = async (event, searchKey, val, tableData) => {
        if (tableData && tableData.data && tableData.data.length) {
            await this.props.updateLastSortFilter(searchKey, val);
        }
    };

    renderResetTableConfigConfirmationModal = () => {
        const { showResetTableConfigModal } = this.state;
        if (!showResetTableConfigModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Do you want to reset table display properties?`}
                        type="cancel"
                        message={"This action cannot be reverted, are you sure?"}
                        onNo={() => this.setState({ showResetTableConfigModal: false })}
                        onYes={() => {
                            this.setState({ showResetTableConfigModal: false });
                            this.props.resetAllTableConfig();
                        }}
                    />
                }
                onCancel={() => this.setState({ showResetTableConfigModal: false })}
            />
        );
    };

    render() {
        const {
            handleGlobalSearch,
            globalSearchKey,
            resetAllFilters,
            resetSort,
            toggleWildCardFilter,
            showViewModal,
            exportTableXl,
            hasSort = true,
            entity = null,
            isColunmVisibleChanged = null,
            tableParams,
            hasHelp = true,
            hasGlobalSearch = true,
            hasWildCardFilter = true,
            hasView = true,
            exportCustomExcel = null,
            exportToWord = null,
            customExcelExportLoading = false,
            hasNewlyCreated,
            hasNewlyEdited,
            tableData,
            resetAll = null,
            showWildCardFilter = false,
            selectedRecomIds,
            clearSelection,
            exportToExcelFromExportHistory,
            hasAdditionalFilters,
            isBudgetPriority,
            hasTableCellEdit,
            toggleLineEditing,
            lineEditingEnabled,
            isSmartChartView = false,
            isCrLinkPicker = false,
            unPinAllColumn = null,
            isMoreFiltered = null,
            toggleMoreFilter,
            openFiltersPopup = null,
            openAdvancedSearch = null,
            advancedSearchCount = 0,
            dashboardFilterParams = {},
            myFilters = {},
            toggleAppliedFiltersPopup,
            filterByRecommendationAssigned = null,
            recommendationAssignedCount,
            isAssignView = false,
            resetAllTableConfig = null,
            openRecommendationLog = null,
            toggleQueriesModal = null,
            toggleSavedViewsModal = null,
            queries = [],
            appliedTableView = [],
            isRecommendationLog = false,
            hasRecommendationTableLog = false,
            RecommendationSection = false,
            hasMeFilter = false,
            setMeFilter,
            meFilterDisabled = false,
            meFilterDisabledTooltip = "",
            assetSurveyProject = false,
            hasRefresh,
            handleRefresh,
            viewOnly = false,
            hasSearchAndReplace = false,
            toggleSearchAndReplaceModal,
            isFound = false,
            showTableSummary = false,
            toggleTableSummary = null,
            tableSummaryLoading = false,
            hasGlobalClientStandardBtn = false,
            hasSurveyedAssetBtn = false,
            syncClientStandardGlobalLoading = false,
            syncsurveyedAssetLoading = false,
            hasGlobalUniformatBtn = false,
            hasImageFilter = false,
            imageFilter = false,
            filterByImages,
            tableName = "",
            hasAIAnalyse = false,
            analyseBtnDisabled = false,
            setShowGlobalSearchField,
            showGlobalSearchField,
            mobileRecom = false,
            isSurveyAsset = false,
            exportPopup,
            groupEditProgressClick,
            showMultiEditPorgress = false,
            progressFailed = false,
            progressLabel = "Background Task Progress",
            hasGoToFunctionality = false,
            hasAdvancedSearch = false,
            hasSurveyedDate = false,
            hasSyncedeDate = false,
            hasIconRefresh = false,
            iconRefreshTooltip = "Refresh Recommendations",
            hasDateFilter = false,
            filterDate,
            globalUniformatLevelLabel = ""
        } = this.props;
        const hasLocalFilters = !!this.props.isRecommendationTable || !!this.props.isAssetTable;
        const withRecommendationCount = recommendationAssignedCount?.list?.find(elem => elem.id === true)?.count || 0;
        const withoutRecommendationCount = recommendationAssignedCount?.list?.find(elem => elem.id === false)?.count || 0;

        const recommendationFilterOptions = [
            { label: "All", value: "", count: withRecommendationCount + withoutRecommendationCount },

            { label: isAssignView ? "With Recommendation" : "Complete CSP Information", value: "true", count: withRecommendationCount },
            { label: isAssignView ? "Without Recommendation" : "Incomplete CSP Information", value: "false", count: withoutRecommendationCount }
        ];
        const isLogDateFiltered =
            filterDate && filterDate?.key?.from && filterDate?.key?.to && filterDate?.filterKey && filterDate?.filterKey?.length > 0;

        let filterCount = 0;
        tableParams &&
            Object.keys(tableParams)
                .filter(f => f !== "list" && f !== "filters")
                .map(f =>
                    (f === "search" ||
                        f === "surveyor" ||
                        f === "requestor" ||
                        f === "me" ||
                        f === "image_or_not" ||
                        f === "infrastructure_request" ||
                        f === "water" ||
                        f === "caption_missing" ||
                        f === "energy" ||
                        f === "fmp" ||
                        f === "facility_master_plan" ||
                        f === "recommendation_type" ||
                        f === "budget_priority" ||
                        f === "recommendation_assigned_true") &&
                    (tableParams[f] || tableParams[f] === false)
                        ? (filterCount = filterCount + 1)
                        : null
                );
        let dashboardFilterCount = getAppliedFiltersCount(
            this.props?.dashboardReducer?.dashboardExtraFilters?.length > 0 && Object.keys(dashboardFilterParams).length > 0
                ? { ...this.props?.dashboardReducer?.filterValues, ...this.props?.dashboardReducer?.tempChartFilters, dashboard: true }
                : dashboardFilterParams
        );
        let myFiltersCount = getAppliedFiltersCount(myFilters);
        let updatedTableParams = { ...tableParams };
        if (tableParams?.list?.["survey_form_for_asset.created_at"]?.filterKey?.[0] && assetSurveyProject) {
            updatedTableParams = {
                ...tableParams,
                filters: {
                    ...tableParams?.filters,
                    "survey_form_for_asset.created_at": tableParams?.list?.["survey_form_for_asset.created_at"]
                },
                list: { ...tableParams?.list }
            };
            delete updatedTableParams?.list?.["survey_form_for_asset.created_at"];
        }
        if (tableParams?.list?.["survey_recommendations.created_at"]?.filterKey?.[0] && assetSurveyProject) {
            updatedTableParams = {
                ...tableParams,
                filters: {
                    ...tableParams?.filters,
                    "survey_recommendations.created_at": tableParams?.list?.["survey_recommendations.created_at"]
                },
                list: { ...tableParams?.list }
            };
            delete updatedTableParams?.list?.["survey_recommendations.created_at"];
        }
        filterCount +=
            dashboardFilterCount +
            (dashboardFilterParams
                ? Object.keys(dashboardFilterParams || {})?.length > 0
                    ? this.props?.dashboardReducer?.dashboardExtraFilters?.length || 0
                    : 0
                : 0) +
            getAssetDashboardAppliedFilterCount(this.props.assetDashboardFilterParams) +
            (this.props.assetChartNavigationFilterCount || 0) +
            myFiltersCount +
            queries?.length +
            getAppliedWildCardFilterCount(assetSurveyProject ? updatedTableParams?.filters : tableParams?.filters) +
            getAppliedListFilterCount(assetSurveyProject ? updatedTableParams?.list : tableParams?.list) +
            advancedSearchCount;
        const hasPinned = tableData?.keys?.some(key => tableData.config && (tableData.config[key]?.pinned || tableData.config[key]?.style));
        const isTableConfigChanged = hasPinned || (isColunmVisibleChanged && isColunmVisibleChanged());
        return (
            <React.Fragment>
                <>
                    <div className="fil-but ml-2 d-flex btm-mar-rc">
                        {hasRefresh && (
                            <button className="btn btn-reset-fl-cmn mr-2" type="button" onClick={handleRefresh}>
                                <span className="icon mr-1">
                                    <img src={refreshIcon} alt="" />
                                </span>
                                <span className="text">Refresh</span>
                            </button>
                        )}
                        {openFiltersPopup && (!isSmartChartView || isCrLinkPicker) && (
                            <>
                                <button
                                    type="button"
                                    className={`filter-button blue-common-btn ${myFiltersCount > 0 ? "bg-th-filtered" : ""} mr-2`}
                                    data-tip={`View Filters`}
                                    data-for="dashboard-icons-right"
                                    onClick={() => openFiltersPopup()}
                                >
                                    <img src={FilterIcon} alt="" />
                                    <span> Filters</span>
                                </button>
                                {openAdvancedSearch && (
                                    <button
                                        type="button"
                                        className={`filter-button blue-common-btn dt-adv-search-btn ${
                                            advancedSearchCount > 0 ? "bg-th-filtered" : ""
                                        } mr-2`}
                                        data-tip="Find tables by the fields inside them"
                                        data-for="dashboard-icons-right"
                                        onClick={() => openAdvancedSearch()}
                                    >
                                        <i className="fas fa-search" />
                                        <span> Advanced Search</span>
                                        {advancedSearchCount > 0 ? <span className="badge-outer">{advancedSearchCount}</span> : null}
                                    </button>
                                )}
                                {tableParams && filterCount !== 0 ? (
                                    <div className="view mr-2" onClick={toggleAppliedFiltersPopup}>
                                        <div className="view-inner filter-all">
                                            <img
                                                src=" /img/filter.svg"
                                                alt=""
                                                className={"filtrImg"}
                                                data-tip="Applied Filters"
                                                data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                            />
                                            <div className="arrow-sec"></div>
                                            <span className="notifyTxt">{filterCount}</span>
                                        </div>
                                    </div>
                                ) : null}
                            </>
                        )}
                        {hasMeFilter && (
                            <>
                                <button
                                    type="button"
                                    className={`filter-button blue-common-btn ${
                                        tableParams?.me || meFilterDisabled ? "bg-th-filtered" : ""
                                    } ${meFilterDisabled ? "cursor-diabled" : ""} mr-2`}
                                    aria-disabled={meFilterDisabled}
                                    data-tip={
                                        meFilterDisabled
                                            ? meFilterDisabledTooltip
                                            : tableParams?.me
                                              ? `View All${!mobileRecom ? "Mobile Assets" : " Mobile Recommendations"}`
                                              : `View my SURVEYED ${!mobileRecom ? "Mobile Assets" : " Mobile Recommendations"}`
                                    }
                                    data-for="table top icons"
                                    onClick={meFilterDisabled ? undefined : setMeFilter}
                                >
                                    <img src={SurveyorIcon} alt="" />
                                    <span> Surveyor</span>
                                </button>
                            </>
                        )}

                        {filterByRecommendationAssigned && (
                            <div className="categ-select-box asset-categ ml-2">
                                <ReactSelect
                                    className={`react-select-container ${viewOnly ? "cursor-disabled" : ""}`}
                                    classNamePrefix="react-select"
                                    value={recommendationFilterOptions.find(elem => elem.value === (tableParams.recommendation_assigned_true || ""))}
                                    onChange={value => filterByRecommendationAssigned(value.value)}
                                    options={recommendationFilterOptions}
                                    isSearchable={false}
                                    formatOptionLabel={(option, meta) => (
                                        <>
                                            {option.label}
                                            {meta.context === "menu" && <span className="float-right">({option.count})</span>}
                                        </>
                                    )}
                                    isLoading={recommendationAssignedCount?.loading}
                                    isOptionDisabled={() => viewOnly}
                                />
                            </div>
                        )}
                        {toggleQueriesModal && !isSmartChartView && (
                            <>
                                <button
                                    type="button"
                                    className={`filter-button blue-common-btn ${queries?.length > 0 ? "bg-th-filtered" : ""} mr-2`}
                                    data-tip={`View Saved Filter`}
                                    data-for="dashboard-icons-right"
                                    onClick={toggleQueriesModal}
                                >
                                    <img src={QuestionIcon} alt="" />

                                    <span> Saved Filters</span>
                                </button>
                            </>
                        )}
                        {toggleSavedViewsModal && !isSmartChartView && (
                            <>
                                <button
                                    type="button"
                                    className={`filter-button blue-common-btn ${appliedTableView?.length > 0 ? "bg-th-filtered" : ""} mr-2`}
                                    data-tip={`View`}
                                    data-for="dashboard-icons-right"
                                    onClick={toggleSavedViewsModal}
                                >
                                    <img src="/img/eye-ico.svg" alt="" />

                                    <span> Saved Views</span>
                                </button>
                            </>
                        )}
                        {hasIconRefresh && handleRefresh && !isSmartChartView && (
                            <button
                                type="button"
                                className="filter-button blue-common-btn recommendation-refresh-icon-btn mr-2"
                                data-tip={iconRefreshTooltip}
                                data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                onClick={e => {
                                    e.preventDefault();
                                    handleRefresh();
                                }}
                            >
                                <img src={refreshIcon} alt="" />
                            </button>
                        )}
                        {showMultiEditPorgress && (
                            <div
                                className={`progress-fil-icn m-1 cursor-pointer`}
                                data-tip={progressFailed ? `Last ${progressLabel} Failed` : `View Last ${progressLabel}`}
                                data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                onClick={() => groupEditProgressClick && groupEditProgressClick()}
                            >
                                <img src={progressFailed ? bgTaskProgressFailedIcon : bgTaskProgressIcon} alt="" />
                            </div>
                        )}
                        {showTableSummary && (
                            <>
                                <div className={`summary-fil-icn ml-1 ${tableSummaryLoading ? "cursor-disabled" : ""}`}>
                                    <img
                                        src={InfoIcon}
                                        alt=""
                                        data-tip={"Show Table Summary"}
                                        data-for="table top icons"
                                        className="cursor-pointer"
                                        onClick={() => !tableSummaryLoading && toggleTableSummary()}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </>
                <div className={`d-flex icon-rc-outer ml-auto`}>
                    {hasGlobalSearch ? (
                        <GlobalSearch
                            handleGlobalSearch={handleGlobalSearch}
                            globalSearchKey={globalSearchKey}
                            additionalParentClass={filterByRecommendationAssigned ? "sr-ast" : ""}
                            isRecommendationLog={this.props?.isRecommendationLog || false}
                            viewOnly={viewOnly}
                            onSearchClick={value => {
                                if (setShowGlobalSearchField) setShowGlobalSearchField(value ?? false);
                            }}
                            hasAdvancedSearch={hasAdvancedSearch}
                        />
                    ) : null}
                    {hasWildCardFilter && this.state.viewFilterModal ? (
                        <Portal
                            body={
                                <FilterValue
                                    filterValues={tableParams}
                                    myFilters={myFilters}
                                    dashboardFilterParams={dashboardFilterParams}
                                    onCancel={() => this.setState({ viewFilterModal: false })}
                                    isMobile={this.props?.isMobile || false}
                                />
                            }
                            onCancel={() => this.setState({ showViewModal: false })}
                        />
                    ) : null}

                    {hasTableCellEdit && !isSmartChartView && (
                        <>
                            <div className="view">
                                <div
                                    className={`view-inner ${lineEditingEnabled ? "bg-th-filtered" : ""}`}
                                    data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                    data-tip={lineEditingEnabled ? `Exit Line Editing Mode` : `Enable Line Editing`}
                                    onClick={() => toggleLineEditing()}
                                >
                                    <img src="/img/Edit.svg" alt="" className="sort-ico flr-crs" />
                                </div>
                            </div>
                            <div className={`view ${lineEditingEnabled ? "" : "d-none"}`}>
                                <div
                                    className={`view-inner ${lineEditingEnabled ? "bg-th-filtered" : ""}`}
                                    data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                    data-tip={`Exit Line Editing Mode`}
                                    onClick={() => toggleLineEditing()}
                                >
                                    <img src="/img/edit_disabled.svg" alt="" className="sort-ico flr-crs" />
                                </div>
                            </div>
                        </>
                    )}
                    {hasSearchAndReplace ? (
                        <div className="view">
                            <div
                                className={`view-inner ${isFound ? " bg-th-filtered" : ""}`}
                                data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                data-tip={`Search and replace`}
                                onClick={toggleSearchAndReplaceModal}
                            >
                                <img src="/img/find-replace.svg" alt="" className="sort-ico flr-crs" />
                            </div>
                        </div>
                    ) : null}
                    {hasSort ? (
                        <div className="view">
                            <div
                                className={`view-inner ${this.isSorted() ? " bg-th-filtered" : ""} ${viewOnly ? "cursor-disabled" : ""}`}
                                data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                data-tip={`Reset Sort`}
                                onClick={() => this.isSorted() && !viewOnly && resetSort()}
                            >
                                <img src="/img/t-arrow-off.svg" alt="" className="sort-ico flr-crs" />
                            </div>
                        </div>
                    ) : null}
                    {hasSyncedeDate ? (
                        <div className="view date-sort">
                            <div
                                className={`view-inner ${
                                    tableParams?.order && tableParams?.order[tableData?.config?.["last_synced_at"]?.searchKey]
                                        ? " bg-th-filtered bg-filt-icon"
                                        : ""
                                } ${viewOnly ? "cursor-disabled" : ""}`}
                                data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                data-tip={`Sort by Last Synced At`}
                                onClick={event =>
                                    !viewOnly &&
                                    this.setSortOrderParamsByArrow(event, tableData?.config?.["last_synced_at"]?.searchKey, "Last Synced At", tableData)
                                }
                            >
                                <img src={syncCalender} alt="" className="sort-ico flr-crs" />
                                {tableParams.order && tableParams.order[tableData?.config?.["last_synced_at"]?.searchKey] === "asc" ? (
                                    <i className={`fas fa-long-arrow-alt-up table-param-rep calend-recom-icon text-danger`} />
                                ) : tableParams.order && tableParams.order[tableData?.config?.["last_synced_at"]?.searchKey] === "desc" ? (
                                    <i className={`fas fa-long-arrow-alt-down table-param-rep calend-recom-icon text-danger`} />
                                ) : null}
                            </div>
                        </div>
                    ) : null}
                    {hasSurveyedDate ? (
                        <div className="view date-sort">
                            <div
                                className={`view-inner ${
                                    tableParams?.order &&
                                    (tableParams?.order[tableData?.config?.["surveyed_time"]?.searchKey] ||
                                        tableParams?.order[tableData?.config?.["asset_surveyed_time"]?.searchKey])
                                        ? " bg-th-filtered bg-filt-icon"
                                        : ""
                                } ${viewOnly ? "cursor-disabled" : ""}`}
                                data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                data-tip={`Sort by Survey Sequence`}
                                onClick={event =>
                                    !viewOnly &&
                                    this.setSortOrderParamsByArrow(
                                        event,
                                        tableData?.config?.["surveyed_time"]?.searchKey || tableData?.config?.["asset_surveyed_time"]?.searchKey,
                                        "Surveyed At",
                                        tableData
                                    )
                                }
                            >
                                <img src={SurveydDateIcon} alt="" className="sort-ico flr-crs" />
                                {tableParams.order &&
                                (tableParams.order[tableData?.config?.["surveyed_time"]?.searchKey] === "asc" ||
                                    tableParams.order[tableData?.config?.["asset_surveyed_time"]?.searchKey] === "asc") ? (
                                    <i className={`fas fa-long-arrow-alt-up table-param-rep calend-recom-icon text-danger`} />
                                ) : tableParams.order &&
                                  (tableParams.order[tableData?.config?.["surveyed_time"]?.searchKey] === "desc" ||
                                      tableParams.order[tableData?.config?.["asset_surveyed_time"]?.searchKey] === "desc") ? (
                                    <i className={`fas fa-long-arrow-alt-down table-param-rep calend-recom-icon text-danger`} />
                                ) : null}
                            </div>
                        </div>
                    ) : null}
                    {hasNewlyCreated ? (
                        <div className="view date-sort">
                            <div
                                className={`view-inner ${
                                    tableParams.order && tableParams.order[tableData?.config?.["created_at"]?.searchKey]
                                        ? " bg-th-filtered bg-filt-icon"
                                        : ""
                                } ${viewOnly ? "cursor-disabled" : ""}`}
                                data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                data-tip={`Sort by Newly Created`}
                                onClick={event =>
                                    !viewOnly &&
                                    this.setSortOrderParamsByArrow(event, tableData?.config?.["created_at"]?.searchKey, "Created At", tableData)
                                }
                            >
                                <img src={NewlyCreated} alt="" className="sort-ico flr-crs" />
                                {tableParams.order && tableParams.order[tableData?.config?.["created_at"]?.searchKey] === "asc" ? (
                                    <i className={`fas fa-long-arrow-alt-up table-param-rep calend-recom-icon text-danger`} />
                                ) : tableParams.order && tableParams.order[tableData?.config?.["created_at"]?.searchKey] === "desc" ? (
                                    <i className={`fas fa-long-arrow-alt-down table-param-rep calend-recom-icon text-danger`} />
                                ) : null}
                            </div>
                        </div>
                    ) : null}
                    {hasNewlyEdited ? (
                        <div className="view date-sort">
                            <div
                                className={`view-inner ${
                                    tableParams.order && tableParams.order[tableData?.config?.["updated_at"]?.searchKey]
                                        ? " bg-th-filtered bg-filt-icon"
                                        : ""
                                } ${viewOnly ? "cursor-disabled" : ""}`}
                                data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                data-tip={`Sort by Newly Edited `}
                                onClick={event =>
                                    !viewOnly &&
                                    this.setSortOrderParamsByArrow(event, tableData?.config?.["updated_at"]?.searchKey, "Updated At", tableData)
                                }
                            >
                                <img src={NewlyEdited} alt="" className="sort-ico flr-crs" />
                                {tableParams.order && tableParams.order[tableData?.config?.["updated_at"]?.searchKey] === "asc" ? (
                                    <i className={`fas fa-long-arrow-alt-up table-param-rep calend-recom-icon text-danger`} />
                                ) : tableParams.order && tableParams.order[tableData?.config?.["updated_at"]?.searchKey] === "desc" ? (
                                    <i className={`fas fa-long-arrow-alt-down table-param-rep calend-recom-icon text-danger`} />
                                ) : null}
                            </div>
                        </div>
                    ) : null}

                    {hasWildCardFilter || isRecommendationLog ? (
                        <>
                            <div className="view">
                                <div
                                    className={`view-inner ${this.isFiltered() ? " bg-th-filtered" : ""} ${viewOnly ? "cursor-disabled" : ""}`}
                                    data-for={"table top icons"}
                                    data-tip={`Filter`}
                                    onClick={() => !viewOnly && toggleWildCardFilter()}
                                >
                                    <img src="/img/filter.svg" alt="" className={`${isRecommendationLog ? "filter-icn" : ""}`} />
                                </div>
                            </div>
                            <div className="view">
                                <div
                                    className={`view-inner  ${this.isFiltered() ? "bg-th-filtered" : ""} ${viewOnly ? "cursor-disabled" : ""}`}
                                    data-tip={`Reset Filters`}
                                    data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                    onClick={() => {
                                        if (showWildCardFilter && !viewOnly) toggleWildCardFilter();
                                        if ((this.isFiltered() || !tableParams?.unlocked) && !viewOnly) resetAllFilters();
                                    }}
                                >
                                    <img src="/img/filter-off.svg" alt="" className="fil-ico" />
                                </div>
                            </div>
                        </>
                    ) : null}
                    {hasDateFilter ? (
                        <div className="view date-filter position-relative" ref={this.logDateFilterWrapRef}>
                            <div
                                className={`view-inner ${
                                    isLogDateFiltered ? " bg-th-filtered bg-filt-icon" : ""
                                } ${viewOnly ? "cursor-disabled" : ""}`}
                                data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                data-tip={`Sort by Log Date`}
                                onClick={e => !viewOnly && this.toggleLogDateFilter(e)}
                            >
                                <img src="/img/time_cal.svg" alt="" className="cursor-pointer" />
                            </div>
                            {this.state.showLogDateFilter ? (
                                <DateFilterCalendar
                                    className="table-top-date-filter-calendar"
                                    filterDate={filterDate}
                                    onChange={this.handleLogDateFilterChangeInternal}
                                />
                            ) : null}
                        </div>
                    ) : null}
                    {exportToExcelFromExportHistory && this.props.isExport && !viewOnly ? (
                        <div className="view ">
                            {this.props.exportExcelHistoryLoading ? (
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            ) : (
                                <div
                                    className="view-inner"
                                    onClick={() => exportToExcelFromExportHistory()}
                                    data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                    data-tip="Export to Excel "
                                >
                                    <img src="/img/excell-new.svg" alt="" className="export" />
                                </div>
                            )}
                        </div>
                    ) : (
                        ""
                    )}
                    {hasView && !viewOnly && (
                        <div className="view">
                            <div
                                className={`view-inner ${resetAllTableConfig && isTableConfigChanged ? "bg-th-filtered" : ""}`}
                                onClick={() => showViewModal()}
                                data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                data-tip={hasGoToFunctionality ? "Column Visibility / GoTo Column" : `Column Hide/Unhide`}
                            >
                                <img src="/img/eye-ico.svg" alt="" className="eye-ico" />
                            </div>
                        </div>
                    )}
                    {resetAllTableConfig && isTableConfigChanged && !viewOnly && (
                        <div className="view">
                            <div
                                className={`view-inner bg-th-filtered`}
                                onClick={e => {
                                    e.preventDefault();
                                    this.setState({ showResetTableConfigModal: true });
                                }}
                                data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                data-tip={appliedTableView?.length ? `Reset Saved View` : `Reset Table Display Properties`}
                            >
                                <img src="/img/reset-eye-icon.svg" alt="" className="eye-ico" />
                            </div>
                        </div>
                    )}
                    {openRecommendationLog && RecommendationSection && hasRecommendationTableLog && (
                        <div className="view ">
                            <span
                                onClick={() => openRecommendationLog()}
                                data-tip={`View Logs`}
                                data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                            >
                                <i className="fas fa-history"></i>
                            </span>
                        </div>
                    )}
                    {!exportToWord && this.props.isExport && exportTableXl && !viewOnly && (
                        <div className="view ">
                            {this.props.tableLoading ? (
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            ) : (
                                <div
                                    className="view-inner"
                                    onClick={() => exportTableXl()}
                                    data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                    data-tip="Export to Excel"
                                >
                                    <img src="/img/excell-new.svg" alt="" className="export" />
                                </div>
                            )}
                        </div>
                    )}
                    {exportToWord && this.props.isExport && !isSmartChartView ? (
                        <div className="view ">
                            <div
                                className="view-inner"
                                onClick={() => this.showSelectExportTypeWordModal(true)}
                                data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                data-tip="Export to Excel/Word"
                                data-place="bottom"
                            >
                                <img src="/img/excell-new.svg" alt="" />
                            </div>
                        </div>
                    ) : null}
                    {exportCustomExcel && this.props.isExport && !viewOnly && (
                        <div className="view ">
                            {customExcelExportLoading ? (
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            ) : (
                                <div
                                    className="view-inner"
                                    onClick={() => exportCustomExcel()}
                                    data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                    data-tip={mobileRecom ? "Summary Export" : "Export to Custom Excel"}
                                >
                                    <img src="/img/excell-new.svg" alt="" className="export export-all-trades" />
                                </div>
                            )}{" "}
                        </div>
                    )}
                    {exportPopup && exportPopup()}

                    {!openFiltersPopup && tableParams && filterCount !== 0 && !isRecommendationLog ? (
                        <div className="view ">
                            <div className="view-inner filter-all position-relative" onClick={this.setFilterModal}>
                                <img
                                    src=" /img/filter.svg"
                                    alt=""
                                    className={"filtrImg"}
                                    data-tip="Applied Filters"
                                    data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                                />
                                <div className="arrow-sec"></div>
                                <span className="notifyTxt">{filterCount}</span>
                            </div>
                        </div>
                    ) : null}
                    {/* {entity && hasHelp ? (
                        <div className={`view ${isBudgetPriority ? "" : "brd-rht"}`}>
                            <div
                                className="view-inner help-icon"
                                data-tip={`Help`}
                                data-for={this.props?.isRecommendationLog?"table-top-icon":"table top icons"}
                                onClick={() => {
                                    this.showHelperModal("tables", entity);
                                }}
                            >
                                <img src="/img/question-mark-icon.png" alt="" className="fil-ico" />
                                <ReactTooltip id={this.props?.isRecommendationLog?"table-top-icon":"table top icons"} effect="solid" place="bottom" backgroundColor="#007bff" />
                            </div>
                        </div>
                    ) : null} */}
                    {hasAdditionalFilters && (
                        <button
                            data-tip={this.props.additionalFilterTooltip || `Recommendation Types`}
                            onClick={e => {
                                e.preventDefault();
                                toggleMoreFilter();
                            }}
                            data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                            class={`btn btn-more-fl mr-2 ${isMoreFiltered && isMoreFiltered() ? " bg-th-filtered" : "active-bg"} ${
                                viewOnly ? "cursor-disabled" : ""
                            }`}
                            disabled={viewOnly}
                        >
                            More <img src="/img/filter.svg" alt="" />
                        </button>
                    )}
                    {(isSurveyAsset || mobileRecom) && hasAIAnalyse && (
                        <button
                            onClick={this.props.onAnalysis}
                            className={`qaqc-passed-btn pr-0 table-analyse-btn ${analyseBtnDisabled ? "cursor-disabled" : ""}`}
                            disabled={analyseBtnDisabled}
                            data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                            data-tip={analyseBtnDisabled ? "No Assets found" : ""}
                        >
                            {this.props.analysisLoading ? (
                                <div className="button-loader d-flex justify-content-center align-items-center mr-1 mt-1">
                                    <div className="spinner-border text-white" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            ) : null}
                            <>AI Analysis</>
                        </button>
                    )}
                    {isSurveyAsset && this.props.hasQaQcClick && (
                        <button
                            onClick={this.props.onQaQcClick}
                            className="qaqc-passed-btn"
                            data-tip={`Convert QA/QC Completed to Production`}
                            data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                        >
                            {this.props.reviewLoading ? (
                                <div className="button-loader d-flex justify-content-center align-items-center">
                                    <div className="spinner-border text-white" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <i class="fas fa-calendar-plus"></i>
                                    Convert to Production
                                </>
                            )}
                        </button>
                    )}
                    {hasImageFilter && (
                        <button
                            className={`btn btn-more-fl mr-2 ${imageFilter === true || imageFilter === false ? "bg-th-filtered" : "active-bg"}`}
                            onClick={() => filterByImages(imageFilter === true ? false : imageFilter === false ? "" : true)}
                            data-for="table top icons"
                            data-tip={
                                imageFilter === true
                                    ? `View ${tableName ?? ""} with No images `
                                    : imageFilter === false
                                      ? `View All ${tableName ?? ""}`
                                      : `View ${tableName ?? ""} with Images`
                            }
                        >
                            <img src="/img/img-icon.svg" alt="" /> Image
                        </button>
                    )}
                    {hasGlobalClientStandardBtn && (
                        <button
                            onClick={() => this.props.onSync("sync-client-standard")}
                            className="qaqc-passed-btn pl-2"
                            data-tip={`Sync From Global Client Standard`}
                            data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                            disabled={syncClientStandardGlobalLoading}
                        >
                            {syncClientStandardGlobalLoading && (
                                <div className="button-loader d-flex justify-content-center align-items-center mt-2 mr-1">
                                    <div className="spinner-border text-white" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            )}
                            <>Sync From Global Client Standard</>
                        </button>
                    )}
                    {hasGlobalUniformatBtn && (
                        <button
                            onClick={() => this.props.onSync("sync-uniformat-level")}
                            className="qaqc-passed-btn pl-2"
                            data-tip={globalUniformatLevelLabel}
                            data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                            disabled={syncClientStandardGlobalLoading}
                        >
                            {syncClientStandardGlobalLoading && (
                                <div className="button-loader d-flex justify-content-center align-items-center mt-2 mr-1">
                                    <div className="spinner-border text-white" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            )}
                            <>{globalUniformatLevelLabel}</>
                        </button>
                    )}

                    {hasSurveyedAssetBtn && (
                        <button
                            onClick={() => this.props.onSync("sync-asset")}
                            className="qaqc-passed-btn pl-2"
                            data-tip={`Sync from surveyed assets`}
                            data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                            disabled={syncsurveyedAssetLoading}
                        >
                            {syncsurveyedAssetLoading && (
                                <div className="button-loader d-flex justify-content-center align-items-center mt-2 mr-1">
                                    <div className="spinner-border text-white" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            )}
                            <>&nbsp;Sync From Surveyed Assets</>
                        </button>
                    )}

                    {resetAll && !viewOnly && (
                        <button
                            class="btn btn-reset-fl-cmn table-btn mr-2"
                            data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                            data-tip={hasLocalFilters ? "Reset all LOCAL Filters & Sort" : `Reset all Filters & Sort`}
                            onClick={e => {
                                e.preventDefault();
                                if (showWildCardFilter) toggleWildCardFilter();
                                if (selectedRecomIds?.length) clearSelection();
                                // if (lineEditingEnabled) toggleLineEditing();
                                if (!resetAllTableConfig && hasPinned && unPinAllColumn) unPinAllColumn();
                                if (
                                    this.isSorted() ||
                                    this.isFiltered() ||
                                    isFound ||
                                    !tableParams?.unlocked ||
                                    myFiltersCount > 0 ||
                                    queries?.length > 0 ||
                                    (isTableConfigChanged && !resetAllTableConfig)
                                )
                                    resetAll();
                            }}
                        >
                            {hasLocalFilters ? "Reset LOCAL Filters & Sort" : "Reset Filters & Sort"}
                        </button>
                    )}

                    {this.props?.hasClose && (
                        <div className="otr-edit-delte text-right close-aset">
                            <span
                                onClick={() => {
                                    popBreadCrumpOnPageClose();
                                    this.props.history.push(findPrevPathFromBreadCrumpData());
                                }}
                                className="edit-icn-bx"
                                data-tip={`Close`}
                                data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                            >
                                <i class="fas fa-window-close"></i>
                            </span>
                        </div>
                    )}
                    {this.props?.hasCreateSurveyProject && (
                        <div className={`create-new-btn recom-lock-btn`}>
                            <Dropdown>
                                <Dropdown.Toggle id="dropdown-basic" className="add-btn">
                                    <span className="edit-icn-bx">
                                        <i className="fas fa-plus pad-bot"></i> Create Asset Survey Project
                                    </span>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => this.props.showAddSurveyProjectForm()}>
                                        <ReactTooltip id="regular" place="left" effect="solid" backgroundColor="#007bff" />
                                        Create New Asset Survey Project
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => this.props.showAddSurveyProjectForm(true)}>
                                        <ReactTooltip
                                            id="similar"
                                            place="bottom"
                                            effect="solid"
                                            backgroundColor="#007bff"
                                            html={true}
                                            className="tooltip-re-cm div"
                                            getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                                        />
                                        Create New Verification Survey Project
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    )}

                    {this.props.children}
                </div>

                {this.renderUploadHelperModal()}
                {this.renderSelectExportTypeModal()}
                {this.renderSelectExportTypeWordModal()}
                {this.renderResetTableConfigConfirmationModal()}
                <ReactTooltip
                    id={this.props?.isRecommendationLog ? "table-top-icon" : "table top icons"}
                    effect="solid"
                    place={`${isRecommendationLog ? "left" : "bottom"}`}
                    backgroundColor="#007bff"
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const { dashboardReducer } = state;
    return {
        dashboardReducer
    };
};

export default withRouter(connect(mapStateToProps)(TableTopIcons));
